import React, { useState } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

const CustomKeyboard = ({
  type,
  newValue,
  setNewValue,
  onEnter,
  onClose,
  showKeyboard,
}) => {
  const [layoutName, setLayoutName] = useState("default");

  const qwertzLayout = {
    default: [
      "1 2 3 4 5 6 7 8 9 0 ß ´ {bksp}",
      "q w e r t z u i o p ü +",
      "a s d f g h j k l ö ä #",
      "y x c v b n m , . - {enter}",
      "{shift} {space} {shift}",
    ],
    shift: [
      '! " § $ % & / ( ) = ? ` {bksp}',
      "Q W E R T Z U I O P Ü *",
      "A S D F G H J K L Ö Ä '",
      "Y X C V B N M ; : _ {enter}",
      "{shift} {space} {shift}",
    ],
  };

  const numpadLayout = {
    default: ["1 2 3", "4 5 6", "7 8 9", ", 0 .", "- {enter} {bksp}"],
  };

  const display = {
    "{enter}": "Enter",
    "{shift}": "Shift",
    "{lock}": "Shift",
    "{space}": " ",
    "{bksp}": "<<<",
  };

  const handleShift = () => {
    setLayoutName(layoutName === "default" ? "shift" : "default");
  };

  const handleKeyPress = (button) => {
    if (button === "{shift}" || button === "{lock}") handleShift();
    if (button === "{enter}") onEnter();
  };

  const keyboardLayout = type === "int" || type === "real" ? numpadLayout : qwertzLayout;
  const keyboardWidth = type === "int" || type === "real" ? "200px" : "500px";
  const keyboardLeft = type === "int" || type === "real" ? "860px" : "710px";

  return (
    showKeyboard && (
      <div
        style={{
          position: "fixed",
          left: keyboardLeft,
          top: "400px",
          width: keyboardWidth,
          height: "260px",
          zIndex: 9999,
          backgroundColor: "#333",
          color: "#fff",
          border: "1px solid #444",
          borderRadius: "5px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "10%",
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
            backgroundColor: "#444",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px",
          }}
        >
          {newValue}
        </div>
        <Keyboard
          layoutName={layoutName}
          layout={keyboardLayout}
          display={display}
          onChange={setNewValue}
          onKeyPress={handleKeyPress}
          theme={"hg-theme-default hg-theme-dark"}
        />
      </div>
    )
  );
};

export default CustomKeyboard;
